import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {ObjectFactory} from "@commons/types";

export interface PVAFormData extends URIAndTrace {
    idAziendaMaster: number | null,
    cdic: string[],
    mansione: string[],
    ruolo: string[],

    qualifica: string[],
    contratti: string[],
    generi: string[],

    gruppo01: string[],
    gruppo02: string[],
    gruppo03: string[],
    gruppo04: string[],
    gruppo05: string[],
    gruppo06: string[],
    gruppo07: string[],
    gruppo08: string[],
    gruppo09: string[],
    gruppo10: string[],
    gruppo11: string[],
    gruppo12: string[],
}

export class PVAFormData {
    static factory: ObjectFactory<PVAFormData> = (json?) => {
        return {
            idAziendaMaster: (json && json.idAziendaMaster) ? json.idAziendaMaster : null,
            //people: [] as number[],
            cdic: (json && json.cdic) ? json.cdic : [] as string[],
            mansione: (json && json.mansione) ? json.mansione : [] as string[],
            ruolo: (json && json.ruolo) ? json.ruolo : [] as string[],

            qualifica: (json && json.qualifica) ? json.qualifica : [] as string[],
            contratti: (json && json.contratti) ? json.contratti : [] as string[],
            generi: (json && json.generi) ? json.generi : [] as string[],

            gruppo01: (json && json.gruppo01) ? json.gruppo01 : [] as string[],
            gruppo02: (json && json.gruppo02) ? json.gruppo02 : [] as string[],
            gruppo03: (json && json.gruppo03) ? json.gruppo03 : [] as string[],
            gruppo04: (json && json.gruppo04) ? json.gruppo04 : [] as string[],
            gruppo05: (json && json.gruppo05) ? json.gruppo05 : [] as string[],
            gruppo06: (json && json.gruppo06) ? json.gruppo06 : [] as string[],
            gruppo07: (json && json.gruppo07) ? json.gruppo07 : [] as string[],
            gruppo08: (json && json.gruppo08) ? json.gruppo08 : [] as string[],
            gruppo09: (json && json.gruppo09) ? json.gruppo09 : [] as string[],
            gruppo10: (json && json.gruppo10) ? json.gruppo10 : [] as string[],
            gruppo11: (json && json.gruppo11) ? json.gruppo11 : [] as string[],
            gruppo12: (json && json.gruppo12) ? json.gruppo12 : [] as string[],

            URI: (json && json.URI) ? json.URI : null,
        };
    }

    /**
     * restituisce true se almeno uno dei filtri è attivo!
     * @param data
     */
    static isActive = (data: PVAFormData): boolean => {
        return data.cdic.length > 0 ||
            data.mansione.length > 0 ||
            data.ruolo.length > 0 ||

            data.qualifica.length > 0 ||
            data.contratti.length > 0 ||
            data.generi.length > 0 ||

            data.gruppo01.length > 0 ||
            data.gruppo02.length > 0 ||
            data.gruppo03.length > 0 ||
            data.gruppo04.length > 0 ||
            data.gruppo05.length > 0 ||
            data.gruppo06.length > 0 ||
            data.gruppo07.length > 0 ||
            data.gruppo08.length > 0 ||
            data.gruppo09.length > 0 ||
            data.gruppo10.length > 0 ||
            data.gruppo11.length > 0 ||
            data.gruppo12.length > 0;
    }
}
